import { render, staticRenderFns } from "./item-thumbnail.vue?vue&type=template&id=3514c17c&"
import script from "./item-thumbnail.vue?vue&type=script&lang=js&"
export * from "./item-thumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports